import axios from 'axios';
import consoleModule, { disconnect } from '../modules/ws.console';

export default {
  login({ commit, state }, user) {
    return new Promise((resolve, reject) => {
      commit('authRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/user/login`,
        data: user,
        method: 'POST'
      })
        .then(resp => {
          const token = resp.data.data.token;
          const user = resp.data.data.user;
          localStorage.setItem('token', token);
          localStorage.setItem('user', JSON.stringify(user));
          document.cookie = `Authorization=${encodeURIComponent(
            token
          )}; max-age=31536000};`;
          axios.defaults.headers.common['Authorization'] = token;
          commit('authRequestSuccess', { token, user });
          consoleModule({ token });
          resolve(resp);
        })
        .catch(err => {
          commit('authRequestError', err);
          localStorage.removeItem('token');
          delete axios.defaults.headers.common['Authorization'];
          reject(err);
        });
    });
  },

  logout({ commit }) {
    return new Promise(resolve => {
      commit('logout');
      localStorage.removeItem('token');
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
      }
      delete axios.defaults.headers.common['Authorization'];
      disconnect();
      resolve();
    });
  }
};
